import { useEffect, useState } from "react";
import APIService from "services/ApiService";
import { ApiKeyCheck } from "reducers/types";

// Asks the server to try the provider's API key against the provider
// (GET /admin/resources/api-keys/{provider}/check — one request to the provider), once per mount while enabled.
// null while checking, when disabled, or when the request to our server fails.
const useApiKeyCheck = (provider: string, enabled: boolean): ApiKeyCheck | null => {
  const [check, setCheck] = useState<ApiKeyCheck | null>(null);

  useEffect(() => {
    if (!enabled) {
      setCheck(null);
      return;
    }
    let active = true;
    new APIService()
      .get(`/admin/resources/api-keys/${provider}/check`)
      .then((res: any) => {
        if (active && res && res.result) {
          setCheck(res.result as ApiKeyCheck);
        }
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, [provider, enabled]);

  return check;
};

export default useApiKeyCheck;
